import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import {
  Login,
  SignUp,
  VeriflyEmail,
  ForgetPassword,
  ForgetPasswordChange,
  Home,
  ConfirmEmail,
  Dashboard,
  Offers,
  ListingOffers,
  ListingDetails,
  OffersDetails,
  ListingDashboard,
  Transactions,
  Notifications,
  TransactionsEmpty,
  UpdateProfile,
  SearchPage,
  PropertyPage,
  PropertyPageShortlet,
  MakeOffer,
  ContactUs,
  AboutUs,
  ListingHome,
  ListingForm1,
  ListingForm2,
  ListingForm3,
  ListingForm4,
  ListingForm5,
  ListingSummary,
  NotFound,
  WatchList,
} from "./export";
import { Layout } from "./components/layout/layout";
import { DashboardLayout } from "./components/layout/dashboardLayout ";
export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/verifly-email" element={<VeriflyEmail />} />
      <Route path="/watch-list" element={<WatchList />} />
      <Route path="/confirm-change" element={<ForgetPasswordChange />} />
      <Route path="/forget-password" element={<ForgetPassword />} />
      <Route path="/accounts" element={<DashboardLayout />} />
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="search" element={<SearchPage />} />
        <Route
          path="property/:idOffer2/:propertyId"
          element={<PropertyPage />}
        />
        <Route
          path="property/shortlet/:propertyId"
          element={<PropertyPageShortlet />}
        />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="make-offer" element={<MakeOffer />} />
        <Route path="listing-summary" element={<ListingSummary />} />
        <Route path="listing-info" element={<ListingHome />} />
        <Route path="listing-form1" element={<ListingForm1 />} />
        <Route path="listing-form2" element={<ListingForm2 />} />
        <Route path="listing-form3" element={<ListingForm3 />} />
        <Route path="listing-form4" element={<ListingForm4 />} />
        <Route path="listing-form5" element={<ListingForm5 />} />
      </Route>
      <Route path="/admin" element={<DashboardLayout />}>
        <Route path="home" element={<Dashboard />} />
        <Route path="listing" element={<ListingDashboard />} />
        <Route path="offers" element={<Offers />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="profile" element={<UpdateProfile />} />
        <Route path="listing-request" element={<ListingOffers />} />
        <Route
          path="offers-details/:offertypeId/:offerId"
          element={<OffersDetails />}
        />
        <Route path="listing-details/:listingId" element={<ListingDetails />} />
      </Route>
      <Route path="transactions-payment" element={<TransactionsEmpty />} />
      <Route path="confirm-email" element={<ConfirmEmail />} />
      <Route path="*" element={<NotFound />} />
    </Route>
  )
);

// /s/:location&:adults&:children&:checkIn&:checkOut
